import React from "react";
import "./Experience.css";

const items = [
    {
        companyName: "GSoC 2021 @ OWASP",
        image: "https://media-exp1.licdn.com/dms/image/C560BAQHk66EsagXmXw/company-logo_100_100/0/1558688235034?e=1629936000&v=beta&t=Y6nC0M-h495jaSTT2cb_FvgCEXesenYlJYRNAHxNtpg",
        position: "Student Developer",
        description: ["Will be working on OWASP Python Honeypot project"],
        time: "May 2021 - Present"
    },
    {
        companyName: "IIT Bombay",
        image: "https://media-exp1.licdn.com/dms/image/C4E0BAQFd0YbG4efCfg/company-logo_100_100/0/1519882262216?e=1628726400&v=beta&t=vX8i9GV4G4OREsYsxB8Q0EbcI8viwcT9pbBKiOfZeec",
        position: "Application Developer",
        description: ["Developed mobile application using flutter.",
            "Used Google Places Api to retrieve data.",
            "Developed REST Api using Django.",
            "Made 2 web scrapers using python.",
            "Developed a web application to map data from mongodb to postgres.\n"],
        time: "Dec 2020 - Mar 2021"
    },
    {
        companyName: "DigiRetail Private Limited",
        image: "https://media-exp1.licdn.com/dms/image/C510BAQE2Ec78OBfJxQ/company-logo_100_100/0/1569406964522?e=1628726400&v=beta&t=L_MZ2-u-FKnzx9gIjtf3SVVFaryHjPGxmu_o7EJ0HtM",
        position: "BackEnd Developer Intern",
        description: ["Developed and Deployed Admin Panel using Django, MySQL, ElasticSearch providing CRUD functionality for core features.", "Deployed Wordpress site for customers.\n"],
        time: "Aug 2020 - Nov 2020"
    },
    {
        companyName: "Script Winter of Code",
        image: "https://media-exp1.licdn.com/dms/image/C560BAQGh8hr-FgbrHw/company-logo_100_100/0/1602422883512?e=1628726400&v=beta&t=3II5BhJ1sZxPi948E6s-3tZPinkuHJLNiYxm9SXvbLI",
        position: "Participant",
        description: ["Contributed to the StarBook project during Script Winter of Code.",
            "Added Time picker, Date picker, various features, added code comments to improve readability of code and many more."],
        time: "Dec 2020 - Feb 2021"
    },
    {
        companyName: "App Team",
        image: "https://media-exp1.licdn.com/dms/image/C4E0BAQE12bbz_AQ4aA/company-logo_100_100/0/1537996560854?e=1628726400&v=beta&t=at77sTMjCk50TCr9fDz8gmEr6zDkJa4pRa5eqZGdK1Q",
        position: "Backend Developer - Executive Member",
        description: ["Developed lot of REST Api’s",
            "Documented the Api’s with proper response and response code.",
            "Made a Quiz Panel from where departmental teams can manage quiz, submissions, leaderboard, upload questions via excel and many more."],
        time: "Sep 2019 - Present"
    },
    {
        companyName: ".EXE",
        image: "https://media-exp1.licdn.com/dms/image/C510BAQEPPF8Z5PzT8w/company-logo_100_100/0/1554835222687?e=1628726400&v=beta&t=EhePzEP3CRXorB4YEg8Yg3tvEqDTYrZq2_-m4BjzotE",
        position: "Full Stack Developer - Executive Member",
        description: [
            "Developed Paradox (A pictorial riddle app!) Mobile Application",
            "Developed Platform for organizing Trade and Code",
            "Trade and Code was an event developed to be held during Nimbus 2k21. The event's focus was to bring an interesting and fun amalgamation of economics and coding."
        ],
        time: "Dec 2020 - Present"
    },];


class Experience extends React.Component {
    render() {
        return <div className={"experience"} id={"experience"}>
            <div className={"row"}>
                {items.map((item, index) => {
                console.log(index % 2);
                return <div
                    key={index}
                    className={"experience-card"}>
                    <img className={"experience-image"} src={item.image} width={75} height={75}/>
                    <h1 className={"experience-position"}>{item.position}</h1>
                    <h1 className={"experience-company"}>{item.companyName}</h1>
                    <h1 className={"experience-time"}>{item.time}</h1>
                    <ul>
                        {item.description.map((desc, index) => {
                            return <li key={index} className={"experience-description"}> {desc} </li>
                        })}
                    </ul>
                </div>;
            })}
            </div>

        </div>;
    }
}

export default Experience;